import { FiltersFormCohabitation } from 'cohabitation/view-models/filter-cohabitation';
import { SearchPerson } from 'shell/view-models/search-anpr';

export interface SearchCohabitation extends SearchPerson {
  nome?: string;
  specieVia?: string;
  via?: string;
}

export const transformSearchCohabitationDataset = (
  values: FiltersFormCohabitation
): SearchCohabitation => {
  const subjectData = { ...values };

  const hasSubjectIdMunicipality = subjectData.codeMunicipality || subjectData.codeIstat;

  const transformedFilters: SearchCohabitation = {
    nome: values?.cohabitationName?.value || undefined,
    specieVia: values?.kindStreet || undefined,
    via: values?.cohabitationStreet?.id?.toString() || undefined,
    criteriRicerca:
      hasSubjectIdMunicipality || subjectData.codeAnpr
        ? {
            // Fixed value for request cohabitation
            tipoScheda: '2',
            idFamigliaConvivenzaComune: hasSubjectIdMunicipality
              ? {
                  idFamigliaConvivenza: subjectData.codeMunicipality || undefined,
                  idFamigliaConvivenzaComuneIstat:
                    subjectData.codeIstat || subjectData.municipalityOfResidence?.id || undefined,
                }
              : undefined,
            identificativoANPR: subjectData.codeAnpr || undefined,
          }
        : undefined,
    datiRichiesta: {
      dataRiferimentoRichiesta: subjectData.dateForm?.toFormat('yyyy-MM-dd') || undefined,
      // Fixed value for request cohabitation
      schedaAnagraficaRichiesta: '4',
      comuneResidenza:
        !subjectData.isNationalResearch && subjectData.municipalityOfResidence?.id
          ? {
              siglaProvinciaIstat: subjectData.municipalityOfResidence?.province || undefined,
              nomeComune: subjectData.municipalityOfResidence?.description,
              codiceIstat: subjectData.municipalityOfResidence?.id || undefined,
            }
          : undefined,
      ricercaNazionale: subjectData.isNationalResearch ? '1' : '0',
      // Fixed value for request cohabitation
      datiAnagraficiRichiesti: ['02', '21', '22'],
    },
  };

  return transformedFilters;
};
